import React, { useState, useEffect } from "react"
import { useSpring, animated } from "react-spring"

const circlePath = `
    M18 2.0845
    a 15.9155 15.9155 0 0 1 0 31.831
    a 15.9155 15.9155 0 0 1 0 -31.831
`

const Wheel = ({ children, stroke, color }) => (
    <div>
        <svg viewBox="0 0 42 42" width="34">
        <path style={{fill: 'none', stroke: 'transparent', strokeWidth: 3.8}} d={circlePath} />
        <animated.path
            style={{fill: 'none', strokeWidth: 2.8, stroke: color}}
            strokeDasharray={stroke}
            d={circlePath}
        />
        {children}
        </svg>
    </div>
);

export function CircularProg({children, color}) {
    const [active, set] = useState(false);
    useEffect(() => set(true),[])

    const props = useSpring({
        stroke: active ? "100, 100" : "0,100",
        config: {
            duration: 2000
        }
    });

    return (
        <div style={{textAlign: 'center'}}>
            <Wheel
                stroke={props.stroke}
                children={children}
                color={color}
            />
        </div>
    );
}
